import { Box, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { CopyToClipboardButton } from 'probonio-shared-ui/component/button/CopyToClipboardButton';
import { useTenant } from 'probonio-shared-ui/module/me';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogState } from '../../../component/dialog';
import { FEATURE_ONEPORTAL } from '../../../constants';
import { fontWeights } from '../../../theme';
import { useWebAppUrl } from '../../../util/use-web-app-url';
import { AddUserAccordion } from './AddUserAccordion';

interface Props {
  dialogState: DialogState;
}

export function formatRegistrationCode(code?: string): string | undefined {
  if (code) {
    const matches = /(\w{4})(\w{4})(\w{4})?/.exec(code);
    return matches ? `${matches[1]}-${matches[2]}${matches[3] ? '-' : ''}${matches[3] || ''}` : undefined;
  }
}

function formatRegistrationLink(appUrl: string, code?: string): string | undefined {
  if (code && appUrl) {
    return FEATURE_ONEPORTAL ? `${import.meta.env.VITE_REGISTRATION_URL}?code=${code}` : `${appUrl}/register/code?code=${code}`;
  }
}

export const AddUserCode: React.FC<Props> = ({ dialogState }) => {
  const { t } = useTranslation('usersModule');
  const { tenant } = useTenant();

  const appUrl = useWebAppUrl();

  return (
    <Box>
      <Typography color="text.secondary" fontSize={14} fontWeight={fontWeights.semiBold} marginBottom={2}>
        {t('createNewUserFields.lead')}
      </Typography>
      <Grid container gap={2} marginBottom={2} flexDirection="column">
        <TextField
          data-test-id="user-add-popup-code-link"
          variant="outlined"
          fullWidth
          label={t('createNewUserFields.registrationLink')}
          value={formatRegistrationLink(appUrl, tenant?.registrationCode) || ''}
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: <CopyToClipboardButton edge="end" value={formatRegistrationLink(appUrl, tenant?.registrationCode)} />,
            },
          }}
          helperText={t('createNewUserFields.linkHelper')}
        />
        <TextField
          data-test-id="user-add-popup-code-realcode"
          variant="outlined"
          fullWidth
          label={t('createNewUserFields.registrationCode')}
          value={formatRegistrationCode(tenant?.registrationCode) || ''}
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: <CopyToClipboardButton edge="end" value={formatRegistrationCode(tenant?.registrationCode)} />,
            },
          }}
          helperText={t('createNewUserFields.codeHelper')}
        />
        <AddUserAccordion dialogState={dialogState} />
      </Grid>
    </Box>
  );
};
